export const AnnualMileageThresholdKm = 3000;
export const AnnualMileageHighKm = 3001;
export const AnnualMileageLowKm = 2999;

